/*
 * Copyright (c) 2023. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import privacyStyle from "../privacyStyle";
import { RS_ADDRESS, RS_ADDRESS_LOCALITY, RS_NAME, RS_POSTAL_CODE, SERVICE_EMAIL } from "../../../services/globalVars";
import { Link } from "react-router";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";

const PrivacyLegalbirdOS = () => {
  return (
    <Box sx={privacyStyle.privacyPage} id="datenschutz">
      <Typography variant={"h1"} sx={privacyStyle.title}>
        Datenschutz
      </Typography>
      <Typography variant={"h2"}>Datenschutzerklärung für Legalbird OS</Typography>
      <Typography variant={"h3"}>Einleitung</Typography>
      <p>
        Für die Legalbird GmbH (<strong>"LEGALBIRD"</strong>) ist der Schutz und die Vertraulichkeit Ihrer Daten von besonderer Bedeutung. Die Erhebung und
        Verwendung Ihrer personenbezogenen Daten erfolgt ausschließlich im Rahmen der gesetzlichen Bestimmungen des geltenden Datenschutzrechts. Mit dieser
        Datenschutzerklärung informieren wir Sie darüber, welche personenbezogenen Daten LEGALBIRD erhebt und zu welchem Zweck die Daten verwendet werden und
        ggf. weitergegeben werden.
      </p>
      <p>
        Bitte lesen Sie diese Datenschutzerklärung vor der Nutzung unserer Legalbird Plattform (<strong>„Legalbird OS“</strong>) sorgfältig durch. Legalbird OS
        ermöglicht Ihnen, Ihre Daten für Rechtsangelegenheiten zentral zu verwalten, sicher zu speichern und mit Ihrem Rechtsanwalt zu teilen (
        <strong>„Dienste“</strong>).
      </p>
      <p>
        Mit der Nutzung von Legalbird OS bestätigen Sie, dass Sie die Datenschutzerklärung zur Kenntnis genommen haben. Bestimmte Datenverarbeitungen sind
        erforderlich, um den Dienst bereitzustellen und vertragliche Leistungen zu erfüllen (Art. 6 Abs. 1 lit. b DSGVO).
      </p>
      <p>
        Falls Sie der Verarbeitung bestimmter Daten nicht zustimmen oder Fragen zur Verarbeitung Ihrer personenbezogenen Daten haben, können Sie uns jederzeit
        kontaktieren.
      </p>
      <br />
      <Typography variant={"h4"}>Verantwortliche Stelle</Typography>
      Verantwortlicher im Sinne des Art. 4 Ziff. 7 DSGVO für die Verarbeitung personenbezogener Daten ist:
      <br />
      <br />
      {RS_NAME}
      <br />
      {RS_ADDRESS}
      <br />
      {RS_POSTAL_CODE} {RS_ADDRESS_LOCALITY}
      <br />
      {SERVICE_EMAIL}
      <br />
      <br />
      <Typography variant={"h4"}>Datenschutzbeauftragter</Typography>
      Bei Fragen zur Verarbeitung Ihrer personenbezogenen Daten, sowie zu Ihren Rechten rund um den Datenschutz wenden Sie sich bitte an:
      <br />
      <br />
      E-Mail: <a href="mailto://datenschutz@legalbird.de">datenschutz@legalbird.de</a>
      <br />
      <br />
      <Typography variant={"h3"}>I. Erhebung, Verarbeitung und Nutzung Ihrer Daten</Typography>
      <p>
        Zur Bereitstellung unserer Dienste ist die Erhebung, Verarbeitung und Nutzung von Daten und Informationen zu Ihrer Person (
        <strong>"personenbezogene Daten"</strong>) erforderlich. Wir verwenden Ihre personenbezogenen Daten gemäß Art. 6 Abs. 1 lit. b DSGVO ausschließlich zur
        Bereitstellung unserer Dienste für Sie bzw. aufgrund Ihrer Einwilligung gemäß Art. 9 Abs. 2 lit. a DSGVO, wenn Sie Ihre Rechtsdaten freiwillig auf
        Legalbird OS hochladen.
      </p>
      <Typography variant={"h4"}>Nutzungsdaten</Typography>
      <p>
        Zur Herstellung der Verbindung, Gewährleistung der Systemsicherheit und aus Gründen der technischen Administration, sowie um die Qualität und die
        Funktionsfähigkeit unserer Webseite zu verbessern und für den Fall einer Strafverfolgung sowie zu statistischen Zwecken erheben wir automatisch Daten
        über den einzelnen Zugriff auf unsere Seiten. Dieser Datensatz besteht unter anderem aus
      </p>
      <ul>
        <li>der Seite, von der aus die Plattform bzw. Webseite angefordert wurde,</li>
        <li>innerhalb der Webseite aufgerufenen Seiten,</li>
        <li>dem Datum und der Uhrzeit der Abfrage,</li>
        <li>der übertragenen Datenmenge,</li>
        <li>dem Zugriffsstatus (Datei übertragen, Datei nicht gefunden),</li>
        <li>Beschreibung des Typs des verwendeten Webbrowsers,</li>
        <li>der IP-Adresse des anfragenden Rechners</li>
        <li>dem verwendeten Betriebssystem</li>
      </ul>
      <p>Rechtsgrundlage für diese Datenverarbeitung ist Art. 6 Abs. 1 lit. f DSGVO (berechtigte Interessen des Verantwortlichen).</p>
      <p>Die o.g. Gründe stellen auch das berechtigte Interesse für die Datenverarbeitung nach Art. 6 Abs. 1 lit. f DSGVO dar.</p>
      <br />
      <Typography variant={"h4"}>Cookies</Typography>
      <p>
        Zur besseren Benutzerführung setzen wir Cookies ein. Durch die Verwendung von Cookies wird die Nutzung von Webseiten für den Nutzer vereinfacht.
        Bestimmte Seiten sind ohne deren Einsatz nicht oder nicht fehlerfrei aufrufbar. Diese Gründe stellen auch das berechtigte Interesse für diese
        Datenverarbeitung nach Art. 6 Abs. 1 lit. f DSGVO dar (die Nutzung von Cookies zu Analysezwecken wird in einem anderen Punkt behandelt). Gängige Browser
        bieten die Einstellungsmöglichkeit, Cookies nicht zuzulassen. Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert
        werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies ausschließen oder das automatische Löschen der Cookies beim Schließen des
        Browsers aktivieren. Es ist nicht gewährleistet, dass Sie auf alle Funktionen dieser Website ohne Einschränkungen zugreifen können, wenn Sie
        entsprechende Einstellungen vornehmen.
      </p>
      <p>
        Einen Überblick über die insgesamt auf Legalbird eingesetzten Technologien finden Sie in unserer <Link to={"/cookierichtlinie"}>Cookierichtlinie</Link>.
        Dort können Sie auch jederzeit Ihre Präferenzen hinsichtlich Ihrer Zustimmung ändern. Die jeweiligen Datenschutzerklärungen finden Sie bei den
        Betreibern der jeweiligen Services.
      </p>
      <br />
      <Typography variant={"h4"}>Google Analytics</Typography>
      <p>
        LEGALBIRD benutzt Google Analytics, einen Webanalysedienst der Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland („Google“). Google
        Analytics verwendet sog. „Cookies“, Textdateien, die auf Ihrem Computer gespeichert werden und die eine Analyse der Benutzung der Website durch Sie
        ermöglichen. Die durch den Cookie erzeugten Informationen über Ihre Benutzung dieser Website werden in der Regel an einen Server von Google in den USA
        übertragen und dort gespeichert. Auf dieser Webseite wurde Google Analytics um den Code „gat._anonymizeIp();“ erweitert, um eine anonymisierte Erfassung
        von IP-Adressen (sog. IP-Masking) zu gewährleisten. Dadurch wird Ihre IP-Adresse vorab von Google innerhalb der EU-Mitgliedsstaaten oder weiteren
        Mitgliedsstaaten oder des Europäischen Wirtschaftsraums gekürzt. Nur in Ausnahmefällen wird die volle IP-Adresse an einen Server von Google in den USA
        übertragen und dort gekürzt. Im Auftrag von LEGALBIRD wird Google diese Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um Reports über
        die Websiteaktivitäten zusammenzustellen und um weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen gegenüber LEGALBIRD
        zu erbringen. Die im Rahmen von Google Analytics von Ihrem Browser übermittelte IP-Adresse wird nicht mit anderen Daten von Google zusammengeführt. Sie
        können die Erfassung der durch den Google-Analytics-Cookie generierten Daten, die sich auf die Nutzung der Webseite beziehen (einschließlich der
        IP-Adresse), durch eine entsprechende Einstellung Ihrer Browser-Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall
        gegebenenfalls nicht sämtliche Funktionen dieser Website vollumfänglich werden nutzen können. Sie können darüber hinaus die Erfassung der durch das
        Cookie erzeugten und auf Ihre Nutzung der Website bezogenen Daten (inkl. Ihrer IP-Adresse) an Google sowie die Verarbeitung dieser Daten durch Google
        verhindern, indem sie das unter dem folgenden Link verfügbare
        <a href="https://tools.google.com/dlpage/gaoptout?hl=de" target="_blank" rel="noopener noreferrer nofollow">
          {" "}
          Browser-Plugin{" "}
        </a>
        herunterladen und installieren.
      </p>
      <p>
        Sie können die Erfassung durch Google Analytics verhindern, indem Sie auf{" "}
        <a href="https://tools.google.com/dlpage/gaoptout?hl=de" target="_blank" rel="noopener noreferrer nofollow">
          diesen Link
        </a>{" "}
        klicken. Es wird ein Opt-Out-Cookie gesetzt, das die zukünftige Erfassung Ihrer Daten beim Besuch dieser Plattform verhindert
      </p>
      <p>
        Weitere Informationen zur Verwendung Ihrer Daten durch google finden Sie
        <a href="https://www.google.com/analytics/terms/de.html" target="_blank" rel="noopener noreferrer nofollow">
          {" "}
          hier
        </a>{" "}
        und
        <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer nofollow">
          {" "}
          hier
        </a>
        .
      </p>
      <p>
        Die Speicherung von Google-Analytics-Cookies erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. LEGALBIRD hat ein berechtigtes Interesse an der
        Analyse des Nutzerverhaltens, um sowohl sein Webangebot als auch seine Werbung zu optimieren und dient damit auch der Finanzierung und
        kundenorientierten Nutzung, Anpassung und Aktualisierung der Webseite.
      </p>
      <br />
      <Typography variant={"h4"}>Verwendung von Google Adwords Conversion-Tracking</Typography>
      <p>
        Wir verwenden auf unserer Website das Online-Werbeprogramm „Google AdWords“ und in diesem Rahmen Conversion-Tracking (Besuchsaktionsauswertung). Das
        Google Conversion Tracking ist ein Analysedienst von Google. Wenn Sie auf eine von Google geschaltete Anzeige klicken, wird ein Cookie für das
        Conversion-Tracking auf Ihrem Rechner abgelegt. Zu diesem Cookie werden in der Regel als Analyse-Werte die Unique Cookie-ID, Anzahl Ad Impressions pro
        Platzierung (Frequency), letzte Impression (relevant für Post-View-Conversions) sowie Opt-out-Informationen (Markierung, dass der Nutzer nicht mehr
        angesprochen werden möchte) gespeichert. Diese Cookies haben eine begrenzte Gültigkeit, enthalten keine personenbezogenen Daten und dienen somit nicht
        der persönlichen Identifizierung. Wenn Sie bestimmte Seiten unserer Website besuchen und das Cookie noch nicht abgelaufen ist, können Google und wir
        erkennen, dass Sie auf die Anzeige geklickt haben und zu dieser Seite weitergeleitet wurden. Jeder Google AdWords-Kunde erhält ein anderes Cookie. Somit
        besteht keine Möglichkeit, dass Cookies über die Websites von AdWords-Kunden nachverfolgt werden können.
      </p>
      <p>
        Die Informationen, die mit Hilfe des Conversion-Cookies eingeholt werden, dienen dem Zweck Conversion-Statistiken zu erstellen. Hierbei erfahren wir die
        Gesamtanzahl der Nutzer, die auf eine unserer Anzeigen geklickt haben und zu einer mit einem Conversion-Tracking-Tag versehenen Seite weitergeleitet
        wurden. Wir bekommen von Google lediglich statistische Auswertungen zur Verfügung gestellt. Anhand dieser Auswertungen können wir erkennen, welche der
        eingesetzten Werbemaßnahmen besonders effektiv sind. Weitergehende Daten aus dem Einsatz der Werbemittel erhalten wir nicht, insbesondere können wir die
        Nutzer nicht anhand dieser Informationen identifizieren. Die Verarbeitung erfolgt auf Grundlage des Art. 6 (1) lit. f DSGVO aus dem berechtigten
        Interesse an zielgerichteter Werbung und der Analyse der Wirkung und Effizienz dieser Werbung.
      </p>
      <p>
        Sie haben das Recht aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit dieser auf Art. 6 (1) f DSGVO beruhenden Verarbeitung Sie
        betreffender personenbezogener Daten zu widersprechen. Dazu können Sie die Speicherung der Cookies durch die Auswahl entsprechender technischer
        Einstellungen Ihrer Browser-Software verhindern.
      </p>
      <p>
        Des Weiteren können Sie in den Einstellungen für Werbung bei Google für Sie personalisierte Werbung deaktivieren. Hier finden Sie eine
        <a href="https://www.google.de/settings/ads" target="_blank" rel="noopener noreferrer nofollow">
          {" "}
          Anleitung von Google{" "}
        </a>{" "}
        dazu. Darüber hinaus können Sie die Verwendung von Cookies durch Drittanbieter deaktivieren, indem sie die
        <a href="https://www.networkadvertising.org/choices/" target="_blank" rel="noopener noreferrer nofollow">
          {" "}
          Deaktivierungsseite der Netzwerkwerbeinitiative{" "}
        </a>
        (Network Advertising Initiative) aufrufen und die dort genannten weiterführenden Information zum Opt-Out umsetzen. Weiterführende Informationen sowie
        die Datenschutzerklärung von Google finden Sie{" "}
        <a href="https://www.google.de/policies/privacy/" target="_blank" rel="noopener noreferrer nofollow">
          hier
        </a>
        .
      </p>
      <Typography variant={"h4"}>Verwendung von Stripe als Zahlungsdienstleister</Typography>
      <p>
        Wir verwenden auf unserer Website das Zahlungstool Stripe. Für Kunden innerhalb von der EU ist Stripe Payments Europe (Europe Ltd., 1 Grand Canal Street
        Lower, Grand Canal Dock, Dublin, Irland) verantwortlich. Das heißt, wenn Sie sich für Stripe als Zahlungsart entscheiden, wird Ihre Zahlung über Stripe
        Payments abgewickelt. Dabei werden Daten, die für den Zahlungsvorgang nötig sind, an Stripe weitergeleitet und gespeichert.
      </p>
      <p>
        Mit Stripe ist es möglich diverse Zahlungsmethoden für unsere Onlinedienste anzubieten. Stripe übernimmt dabei den gesamten Zahlungsvorgang. Ein großer
        Vorteil von Stripe ist hier, dass Sie während des Zahlungsvorgangs nie unsere Website bzw. den Shop verlassen müssen und die Zahlungsabwicklung sehr
        schnell erfolgt.
      </p>
      <p>
        Wir bieten den Dienst also zur Abwicklung von vertraglichen bzw. rechtlichen Beziehungen (Art. 6 Abs. 1 lit. b DSGVO) an. Der erfolgreiche Einsatz des
        Dienstes bedarf ferner Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO), soweit für den Einsatz die Zulassung von Cookies notwendig ist.
      </p>
      <Typography variant={"h4"}>Google Tag Manager (GTM)</Typography>
      <p>
        Wir nutzen den GTM zur zentralen Verwaltung von Website-Tags. Dabei werden keine personenbezogenen Daten gespeichert, sondern lediglich technische
        Informationen (z. B. Browsertyp, Gerätedaten, IP-Adresse, Zugriffszeit) zur Gewährleistung des ordnungsgemäßen Betriebs erhoben.
      </p>
      <p>
        Die Datenverarbeitung erfolgt auf Basis unseres berechtigten Interesses (Art. 6 Abs. 1 lit. f DSGVO). Wir haben mit Google Ireland Limited einen Vertrag
        zur Auftragsverarbeitung abgeschlossen, der die DSGVO-konforme Verarbeitung sicherstellt.
      </p>
      <Typography variant={"h4"}>Google Maps Autocomplete</Typography>
      <p>
        Zur Unterstützung einer fehlerfreien Adresserfassung in Legalbird OS nutzen wir den Dienst Google Maps Autocomplete (Google Ireland Limited, Gordon
        House, Barrow Street, Dublin 4, Irland). Während der Eingabe werden Ihre Adressfragmente und Ihre IP-Adresse an Google übertragen, um Vorschläge zu
        generieren. Die Verarbeitung erfolgt auf Grundlage Ihrer Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO. Die Einwilligung kann jederzeit mit Wirkung für
        die Zukunft über unsere Cookie-Präferenzen angepasst werden. Weitere Informationen finden Sie in der{" "}
        <a href="https://www.google.com/policies/privacy/" target="_blank" rel="noopener noreferrer nofollow">
          Datenschutzerklärung von Google
        </a>
        .
      </p>
      <Typography variant={"h4"}>Webfonts</Typography>
      <p>
        Auf dieser Webseite verwenden wir Web-Fonts (GoogleFonts, Adobe Typekit, Fonts.com o.ä.), also Schriften, die u.U. nicht auf Ihrem Endgerät vorhanden
        sind. Für diesen Dienst greifen wir auf eine Schrifttypenbibliothek zurück. Beim Aufruf unserer Webseite werden Web-Fonts von einem Server (Google,
        Adobe o.ä.) geladen. Dabei kann die IP-Adresse der aufrufenden Besucher an den Anbieter (z.B. Google, Adobe - Adobe Systems Inc., San Jose, Kalifornien,
        USA) übertragen werden. (GoogleFonts-Opt-out: https://adssettings.google.com)
      </p>
      <p>
        Rechtsgrundlage für diese Datenverarbeitung ist Art. 6 Abs. 1 lit. f DSGVO (berechtigte Interessen des Verantwortlichen). Der Betreiber hat ein
        berechtigtes Interesse an einer gut lesbaren und strukturierten Darstellung von Schriften und Inhalten (Usability) auf der Webseite.
      </p>
      <Typography variant={"h4"}>Newsletter</Typography>
      <p>
        Wir bieten die Möglichkeit, sich per Newsletter über Neuerungen auf unserer Webseite zu informieren. Hierfür benötigen wir Ihre E-Mail-Adresse. Wenn Sie
        zu einem späteren Zeitpunkt den Newsletter nicht mehr beziehen möchten, ist dies über eine einfache E-Mail Abmeldung möglich.
      </p>
      <p>
        Sofern Sie eine Einwilligung in die werbliche Ansprache durch LEGALBIRD erteilt haben, erhebt, verarbeitet und nutzt LEGALBIRD Ihre Nutzerprofil-Daten,
        Buchungsdaten und Zusatzinformationen sowie Ihre Zugriffszeiten auf Ihr Nutzerprofil, um Ihre Nutzergewohnheiten besser zu verstehen und Ihnen für Sie
        möglicherweise interessante Informationen zu weiteren Dienstleistung zu übersenden. Sie können eine einmal erteilte Einwilligung in die Nutzung Ihrer
        Daten für werbliche Zwecke (z.B. Newsletter) durch LEGALBIRD und Anwalt von LEGALBIRD jederzeit durch E-Mail an {SERVICE_EMAIL} widerrufen.
      </p>
      <p>
        Rechtsgrundlage für die Verarbeitung der Daten nach Anmeldung zum Newsletter durch den Nutzer ist die Einwilligung des Nutzers, Art. 6 Abs. 1 lit. a
        DSGVO. Rechtsgrundlage für den Versand des Newsletters infolge des Verkaufs von Dienstleistungen ist § 7 Abs. 3 UWG.
      </p>
      <Typography variant={"h4"}>Allgemeine Registrierung</Typography>
      <p>
        Bei der Anmeldung in Legalbird OS müssen Sie Ihren Ihre E-Mail-Adresse angeben und Ihr Kennwort festlegen (<strong>"Nutzerprofil-Daten"</strong>). Diese
        Daten benötigen wir zur Einrichtung Ihres individuellen, nur für Sie zugänglichen Nutzerkontos für Legalbird OS (<strong>"Legalbird-Konto</strong>),
        über das wir Ihnen unsere Dienste zur Verfügung stellen. Wir können es Ihnen auch ermöglichen, sich über einen anderen Dienstleister anzumelden. Dies
        ist jedoch freiwillig und stellt lediglich eine Ergänzung des üblichen Anmeldeprozesses dar. Sollten Sie von diesem Angebot Gebrauch machen, unterliegt
        die Nutzung dieses anderen Dienstes den Nutzungsbedingungen des jeweiligen Anbieters und wir haben keinen Einfluss darauf, wie dieser Ihre Daten
        verarbeitet. Bitte machen Sie sich daher mit den Datenschutzbestimmungen des Dienstleisters vertraut.
      </p>
      <Typography variant={"h4"}>Weitere persönliche Daten und Falldaten</Typography>
      <p>
        Sie können in Ihrem Legalbird-Konto auch weitere Daten, die Sie in Ihrem Legalbird-Konto speichern möchten oder für die Sie unsere Dienste in Anspruch
        nehmen möchten, angeben oder speichern (<strong>"weitere persönliche Daten"</strong>). Weitere persönliche Daten sind z.B. Ihr Name und Vorname, Ihr
        Geschlecht, Ihr Einkommen oder die Beschreibung Ihrer familiäre Situation. Die Erhebung und Verarbeitung Ihrer weiteren persönlichen Daten durch uns
        erfolgt ausschließlich, um Ihnen unsere Dienste bereitzustellen.
      </p>
      <p>
        Sie können in Ihrem Legalbird-Konto Daten und Dokumente mit Informationen über Ihre rechtlichen Fälle wie z.B. Arbeitsverträge, zu Ihrer
        Rechtsschutzversicherung, zu Ihrem Arbeitgeber, zu Ihrer Ordnungswidrigkeit oder zu Ihrem Ehepartner (<strong>"Falldaten"</strong>) hochladen und
        speichern. Die Erhebung und Verarbeitung Ihrer Falldaten durch uns erfolgt ausschließlich, um Ihnen unsere Dienste bereitzustellen.
      </p>
      <p>
        Zur Kommunikation mit den von Ihnen ausgewählten Anwälten können Sie Nachrichten direkt über Ihr Legalbird-Konto an den gewünschten Anwalt schreiben (
        <strong>"Nachrichtenmodul"</strong>). Wenn Sie das Nachrichtenmodul nutzen, speichern wir die von Ihnen übermittelten Nachrichten (
        <strong>"Nachrichtendaten"</strong>). Die Erhebung und Verarbeitung Ihrer Nachrichtendaten durch uns erfolgt ausschließlich, um Ihnen unsere Dienste
        bereitzustellen.
      </p>
      <p>
        Mit dem Hochladen der Dokumente bzw. der Einladung an Anwälte zum Hochladen erteilen Sie Ihre Einwilligung, dass wir die betroffenen weiteren
        persönlichen Daten und Falldaten in Legalbird-Konto für Sie speichern und im Einklang mit dieser Datenschutzerklärung für Sie bereithalten. Sofern Sie
        diese Einwilligung widerrufen möchten, können Sie die Dokumente jederzeit aus Ihrem Legalbird-Konto löschen lassen. Sofern Sie Ihr Legalbird-Konto per
        E-Mail an {SERVICE_EMAIL} löschen möchten, wird LEGALBIRD Ihre Daten sperren und von der weiteren Verarbeitung ausnehmen.
      </p>
      <p>
        Zur Verbesserung der Plattformdienste kann Legalbird KI-gestützte Technologien nutzen, z. B. zur Verarbeitung allgemeiner Anfragen oder zur technischen
        Unterstützung der Fallverwaltung.{" "}
        <strong>Hierzu können auch Systeme zur automatisierten Erkennung und Analyse von Textinhalten aus Dokumenten eingesetzt werden.</strong> Dies kann auch
        die Nutzung von Diensten externer KI-Anbieter wie <strong>Google Ireland Limited (über die Plattform Google Vertex AI)</strong> und OpenAI Ireland
        Limited umfassen. Diese Verarbeitung erfolgt auf Grundlage des berechtigten Interesses gemäß Art. 6 Abs. 1 lit. f DSGVO. Diese Daten werden von uns in
        anonymisierter oder pseudonymisierter Form zur Auswertung und Verbesserung unserer Dienste genutzt, wobei ein Rückschluss auf Ihre Person ausgeschlossen
        oder durch geeignete technische Maßnahmen erschwert wird.
      </p>
      <p>
        Die Beauftragung von Google Ireland Limited <strong>(einschließlich Google Cloud / Vertex AI)</strong> und OpenAI Ireland Limited erfolgt gemäß Art. 28
        DSGVO in Verbindung mit entsprechenden Auftragsverarbeitungsverträgen. Diese Anbieter agieren dabei als weisungsgebundene Auftragsverarbeiter und nutzen
        die übermittelten Daten nicht für eigene Zwecke.{" "}
        <strong>Soweit möglich erfolgt die Verarbeitung in Rechenzentren innerhalb der Europäischen Union.</strong> Eine Übermittlung an verbundene Unternehmen
        von Google Ireland Limited und OpenAI Ireland Limited in den USA kann nicht ausgeschlossen werden. In diesem Zusammenhang stellen wir durch geeignete
        Schutzmaßnahmen, insbesondere durch den Abschluss von Standardvertragsklauseln der EU-Kommission, sicher, dass Ihre Daten im Einklang mit den Art. 44
        ff. DSGVO verarbeitet werden. Weitere Informationen finden Sie in den „Data Processing Addenda“ (DPA) der jeweiligen Anbieter.
      </p>
      <Typography variant={"h3"}>II. Weitergabe an Dritte</Typography>
      <p>
        Eine Weitergabe Ihrer personenbezogenen Daten an Dritte erfolgt nur, soweit dies zur Bereitstellung und Nutzung unserer Dienste und zur
        Zahlungsabwicklung unbedingt notwendig ist. Diese Weitergaben sind für die ordnungsgemäße Erbringung unserer Dienste erforderlich und erfolgt im
        Einklang mit dem geltenden Datenschutzrecht.
      </p>
      <Typography variant={"h4"}>Unsere Dienstleister</Typography>
      <p>
        Wir beauftragen dritte Unternehmen mit der Erfüllung von Aufgaben zum Zweck der Bereitstellung unserer Dienste (<strong>"Auftragsverarbeiter"</strong>).
        Unsere Auftragsverarbeiter haben Zugang zu personenbezogenen Daten, die zur Erfüllung ihrer Aufgaben benötigt werden. Wir verlangen von unseren
        Auftragsverarbeitern im Rahmen der gesetzlichen Anforderungen eine Einverständniserklärung zur vertraulichen Behandlung sämtlicher an diese
        weitergegebener Informationen sowie zur ausschließlichen Nutzung der Informationen im Rahmen des Vertragszwecks.
      </p>
      <p>
        Eine Übermittlung personenbezogener Daten an Länder außerhalb der Europäischen Union (EU) bzw. des Europäischen Wirtschaftsraums (EWR) erfolgt
        grundsätzlich nicht. Sollte in Einzelfällen eine solche Übermittlung erforderlich sein – etwa zur Nutzung bestimmter Dienste (z.B.
        Zahlungsdienstleister, IT-Dienstleister oder die unter "Weitere persönliche Daten und Falldaten" genannten KI-Dienstleister mit Sitz in Drittstaaten) –
        erfolgt sie nur im Einklang mit den Vorgaben der Art. 44 ff. DSGVO. Dabei stellen wir sicher, dass passende{" "}
        <strong>Standardvertragsklauseln (SCCs)</strong> der EU-Kommission oder vergleichbare Schutzmaßnahmen verwendet werden, um ein angemessenes
        Datenschutzniveau zu gewährleisten.
      </p>
      <Typography variant={"h4"}>Von Ihnen ausgewählte Anwälte</Typography>
      <p>
        Nur dann, wenn Sie alle oder einzelne Falldaten und/oder weiteren persönlichen Daten und/oder Nachrichtendaten an einen von Ihnen ausgewählten Anwalt
        freigegeben (gemeinsam <strong>"freigegebene Daten"</strong>) und dadurch Ihre Einwilligung erklärt haben, geben wir diese freigegebenen Daten an den
        Anwalt weiter.
      </p>
      <Typography variant={"h4"}>Rechtswidrige Nutzung von Legalbird OS</Typography>
      <p>
        Wenn es zur Aufklärung einer rechtswidrigen Nutzung von Legalbird OS dient oder für die Rechtsverfolgung erforderlich ist, werden personenbezogene Daten
        an die Strafverfolgungsbehörden sowie ggf. an geschädigte Dritte weitergeleitet. Dies geschieht jedoch nur dann, wenn konkrete Anhaltspunkte für ein
        gesetzwidriges bzw. missbräuchliches Verhalten vorliegen. Eine Weitergabe kann auch dann stattfinden, wenn dies der Durchsetzung der AGB oder anderer
        Vereinbarungen dient. LEGALBIRD ist zudem gesetzlich verpflichtet, auf Anfrage bestimmten öffentlichen Stellen Auskunft zu erteilen. Dies sind
        Strafverfolgungsbehörden, Behörden, die bußgeldbewährte Ordnungswidrigkeiten verfolgen und die Finanzbehörden.
      </p>
      <Typography variant={"h3"}>III. Datensicherheit</Typography>
      <p>
        Ihre personenbezogenen Daten werden während der Übertragung über das Internet mittels Transport Layer Security / Secure Sockets Layer (TLS / SSL)
        verschlüsselt.
      </p>
      <p>
        Wir sichern unsere Website und sonstigen Systeme durch technische und organisatorische Maßnahmen gegen Verlust, Zerstörung, Zugriff, Veränderung oder
        Verbreitung Ihrer Daten durch unbefugte Personen.
      </p>
      <Typography variant={"h3"}>IV. Speicherdauer und Löschung</Typography>
      <p>
        Das Kriterium für die Dauer der Speicherung von personenbezogenen Daten ist die jeweilige gesetzlich vorgeschriebene Aufbewahrungsfrist. Nach Ablauf der
        Frist werden die entsprechenden Daten routinemäßig gelöscht, sofern sie nicht mehr zur Vertragserfüllung oder Vertragsanbahnung erforderlich sind.
      </p>
      <p>
        Soweit Ihre Daten für die vorgenannten Zwecke nicht mehr erforderlich sind, werden sie gelöscht. Soweit Daten aus gesetzlichen Gründen aufbewahrt werden
        müssen, werden diese gesperrt. Die Daten stehen einer weiteren Verwendung dann nicht mehr zur Verfügung.
      </p>
      <p>
        Sie können Ihren Account nicht selbständig löschen, jedoch jederzeit eine Löschung Ihrer Daten per E-Mail an {SERVICE_EMAIL} anfordern. Wir löschen Ihre
        Daten auf Anforderung, insofern diese nicht aus Abrechnungsgründen oder zur Wahrung gesetzlicher Aufbewahrungsfristen benötigt werden.
      </p>
      <Typography variant={"h3"}>VI. Ihre Rechte</Typography>
      <Typography variant={"h4"}>Widerrufsrecht</Typography>
      <p>
        Sie können Ihre Einwilligung zur Erhebung und Verarbeitung Ihrer optionalen personenbezogenen Daten jederzeit mit Wirkung für die Zukunft widerrufen.
        Die für die Erbringung unserer Dienstleistungen zwingend erforderlichen Datenverarbeitungen erfolgen auf Basis gesetzlicher Vorgaben bzw. zur
        Vertragserfüllung und können daher nicht widerrufen werden, damit unsere Dienstleistung in Anspruch genommen werden kann.
      </p>
      <Typography variant={"h4"}>Auskunftsanspruch</Typography>
      <p>
        Sie haben das Recht, gemäß § 34 BDSG bzw. Art. 15 DSGVO jederzeit von uns Auskunft zu verlangen über die zu Ihrer Person gespeicherten Daten, auch
        soweit sie sich auf die Herkunft dieser Daten beziehen, ebenso zu den Empfängern oder den Kategorie von Empfängern, an die Ihre Daten weitergegeben
        werden, sowie zum Zweck der Speicherung.
      </p>
      <Typography variant={"h4"}>Weitere Rechte</Typography>
      <p>
        Sie haben das Recht, gemäß Art. 16 DSGVO die Berichtigung unrichtiger personenbezogener Daten und gemäß Art. 17 DSGVO die Löschung oder gemäß Art. 18
        DSGVO die Sperrung oder Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Ferner können Sie gemäß Art. 20 DSGVO die Herausgabe
        der zu Ihnen gespeicherten personenbezogenen Daten in einem gängigen Dateiformat an Sie selbst oder einen Dritten verlangen. Sofern wir Ihre
        personenbezogenen Daten aufgrund unserer überwiegenden Interessen (Art. 6 Abs. 1 lit. f DSGVO) verarbeiten, können Sie einer darauf gestützten
        Verarbeitung gemäß Art. 21 DSGVO widersprechen, sofern hierfür überwiegende Gründe bestehen, die sich aus Ihrer besonderen Situation ergeben. Sie können
        ferner der Zusendung von Direktwerbung widersprechen. Sollten Sie der Auffassung sein, dass wir Ihre Daten nicht im Einklang mit geltendem Recht
        verarbeiten, können Sie eine Beschwerde bei einer zuständigen Aufsichtsbehörde einlegen, z.B. an Ihrem Wohnort.
      </p>
      <p>Stand: 21.04.2026</p>
    </Box>
  );
};

export default PrivacyLegalbirdOS;
